export function loadString(key: string): string | undefined {
  try {
    return localStorage.getItem(key) ?? undefined
  } catch {
    return undefined
  }
}

export function saveString(key: string, value: string): boolean {
  try {
    localStorage.setItem(key, value)
    return true
  } catch {
    return false
  }
}

export function load<T>(key: string): T | undefined {
  try {
    const almostThere = localStorage.getItem(key)
    return JSON.parse(almostThere ?? '')
  } catch {
    return undefined
  }
}

export function save<T>(key: string, value: T): boolean {
  try {
    return saveString(key, JSON.stringify(value))
  } catch {
    return false
  }
}

export function remove(key: string): void {
  localStorage.removeItem(key)
}

export function clear(): void {
  localStorage.clear()
}

/**
 * Keys that should persist across logout/login sessions
 */
const PERSISTENT_KEYS = [
  'beforeYouStartPopup', // User-specific popup state should persist across sessions
]

/**
 * Clear localStorage while preserving specific keys that should persist across sessions
 */
export function clearExceptPersistent(): void {
  // Save persistent data
  const persistentData: Record<string, string | null> = {}
  for (const key of PERSISTENT_KEYS) {
    persistentData[key] = localStorage.getItem(key)
  }

  // Clear everything
  localStorage.clear()

  // Restore persistent data
  for (const key of PERSISTENT_KEYS) {
    const value = persistentData[key]
    if (value !== null) {
      localStorage.setItem(key, value)
    }
  }
}
